export enum TravelDirection {
  NoTransportation,
  OneWay,
  TwoWay,
}
